import React from "react";
import ExternalScripts from "../../../common/ExternalScripts";

const FAQSection = () => {
  return (
    <div>
      <ExternalScripts/>

      {/* faq-inner-section */}
      <section className="faq-inner-section layout-radius">
        {/* faq-section */}
        <div className="faqs-section pt-0">
          <div className="inner-container">
            {/* FAQ Column */}
            <div className="faq-column wow fadeInUp" data-wow-delay="400ms">
              <div className="inner-column">
                <div className="boxcar- text-center">
                  <h2 className="title">General</h2>
                </div>
                <ul className="widget-accordion wow fadeInUp">
                  {/*Block*/}
                  <li className="accordion block active-block">
                    <div className="acc-btn active">
                      What is Car Junction ? 
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content current">
                      <div className="content">
                        <div className="text">
                          Car Junction is a car listing platform where users can browse cars and directly connect with sellers through WhatsApp for further discussion.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      How can I contact the seller?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                          Each car listing includes a “Chat on WhatsApp” option that allows you to directly contact the seller for price, availability, and other details.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Do you offer test drives or inspections?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Test drive and inspection details are discussed directly on WhatsApp, depending on the car and location.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Are there any hidden charges?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                          No. We follow transparent pricing. Any applicable costs are clearly communicated before you proceed with the purchase.
                        </div>
                      </div>
                    </div>
                  </li>
                  {/*Block*/}
                  <li className="accordion block">
                    <div className="acc-btn">
                      Are the cars inspected before listing?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Yes. Every car is inspected for condition and basic documentation before being listed on our platform.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="accordion block">
                    <div className="acc-btn">
                      Can I negotiate the car price?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Price discussions and negotiations are handled directly through WhatsApp with our sales team.
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="accordion block">
                    <div className="acc-btn">
                      Is test drive available?
                      <div className="icon fa fa-plus" />
                    </div>
                    <div className="acc-content">
                      <div className="content">
                        <div className="text">
                         Test drive availability depends on the car and location. Please contact us on WhatsApp for details.
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* End faqs-section */}
        {/* faq-section */}
        {/* End faqs-section */}
      </section>
      {/* End faq-inner-section */}
    </div>
  );
};

export default FAQSection;
